import { generatePath, useParams } from 'react-router';

import theme from '@/constants/theme';
import BackButton from '@/components/admin/BackButton';
import CreateEditContentForm from '@/components/admin/contents/CreateEditContentForm';
import { routes } from '@/constants/routes';

const CreateEditContent = () => {
  const { contentId, routeId } = useParams();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 16,
        paddingTop: 16,
      }}
    >
      <BackButton href={generatePath(routes.admin.routes.detail, { routeId })} >Regresar a la ruta</BackButton>
      <h1 style={{ color: theme.colors.text.title }}>
        {contentId ? (
          <>
            Editar Contenido:
            <span style={{ color: theme.colors.text.caption, marginLeft: 8 }}>{contentId}</span>
          </>
        ) : (
          'Crear Contenido'
        )}
      </h1>
      <CreateEditContentForm contentId={contentId} routeId={routeId} />
    </div>
  );
};

export default CreateEditContent;
